/* Feedogo: "My feedings" (a small link just below the balance box) and "Report a problem" on the signed-in user's own feeding clips.
   The clip cards are drawn inside the feeder iframe by the big section file, so (like the other feedogo-*.js
   patches) we don't edit it: we watch the clip grid and add a link under "Share clip" on clips the backend says
   are this user's paid feeds (/api/my-clips). The link opens a small form that posts /api/report; an admin checks
   the clip and refunds the Heart Coins (docs/FEED-REPORTS.md in the repo). "My feedings" lists the same feeds with their clips
   so a user can pick one and report it there; it is a quiet text link, like an order history, not a "refund" button. */
(function () {
  'use strict';
  var FRAME_ID = 'feedogo-feeder-frame';
  var API = window.FEEDOGO_REPORT_API || 'https://srv1134592.hstgr.cloud:8443';
  var mine = {}, rows = [], fetchedAt = 0, busy = false, seen = '', waiters = [];

  function frame() {
    try {
      var f = document.getElementById(FRAME_ID);
      var w = f && f.contentWindow, d = w && w.document;
      var grid = d && d.getElementById('recordingGrid');
      return grid ? { w: w, d: d, grid: grid } : null;
    } catch (e) { return null; }
  }
  function auth(fr) {
    var c = fr.w.feedogoCustomer || window.feedogoCustomer;
    return c && c.loggedIn && c.auth ? c.auth : null;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function post(path, body) {
    return fetch(API + path, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, j: j }; }); });
  }

  var CSS =
    '.recording-report{display:block;margin-top:8px;padding:0;border:0;background:none;color:#738379;font:inherit;font-size:11px;text-decoration:underline;cursor:pointer}' +
    '.recording-report:hover{color:#123f34}' +
    '.recording-report-status{display:block;margin-top:8px;font-size:11px;color:#738379}' +
    'body[data-page="feed"] .recording-report,body[data-page="feed"] .recording-report-status{font-size:9px;margin-top:5px;text-align:center;width:100%}' +
    '.clip-report-dialog{width:min(420px,calc(100vw - 32px));box-sizing:border-box;border:0;border-radius:18px;padding:22px;color:#123f34;box-shadow:0 20px 60px rgba(0,0,0,.25)}' +
    '.clip-report-dialog::backdrop{background:rgba(10,30,24,.55)}' +
    '.clip-report-dialog h3{margin:0 0 8px;font-size:18px}' +
    '.clip-report-opt[hidden]{display:none}' +
    '.clip-report-dialog p{margin:0 0 14px;font-size:13px;line-height:1.5;color:#52635a}' +
    '.clip-report-opt{display:flex;gap:8px;align-items:center;padding:12px;border:1px solid #cddfd2;border-radius:12px;font-size:14px;font-weight:600;margin-bottom:10px}' +
    '.clip-report-dialog textarea{width:100%;box-sizing:border-box;border:1px solid #cddfd2;border-radius:12px;padding:10px;font:inherit;font-size:13px;resize:vertical}' +
    '.clip-report-err{color:#b3261e!important;margin:10px 0 0!important}' +
    '.clip-report-act{display:flex;justify-content:flex-end;gap:8px;margin-top:14px}' +
    '.clip-report-act button{min-height:40px;padding:0 16px;border-radius:999px;border:1px solid #cddfd2;background:#fff;color:#123f34;font:inherit;font-weight:700;cursor:pointer}' +
    '.clip-report-act button[type=submit]{background:#123f34;border-color:#123f34;color:#d8f36c}' +
    '.clip-report-act button:disabled{opacity:.6}' +
    '.fg-myfeeds-link{order:7;display:block;margin:6px 6px 0 auto;padding:0;border:0;background:none;color:#52635a;font:inherit;font-size:12px;text-decoration:underline;text-underline-offset:2px;cursor:pointer}' +
    '.fg-myfeeds-link:hover{color:#123f34}' +
    // desktop: less padding under the link so the card (and the Live Love panel lined up with it) ends right below it
    '@media(min-width:1025px){.feed-card:has(.fg-myfeeds-link){padding-bottom:12px!important}}' +
    '.fg-feeds-dialog{width:min(560px,calc(100vw - 24px));max-height:min(80vh,720px);box-sizing:border-box;border:0;border-radius:18px;padding:0;color:#123f34;box-shadow:0 20px 60px rgba(0,0,0,.25)}' +
    '.fg-feeds-dialog::backdrop{background:rgba(10,30,24,.55)}' +
    '.fg-feeds-head{display:flex;align-items:center;justify-content:space-between;padding:18px 20px 10px}' +
    '.fg-feeds-head h3{margin:0;font-size:18px}' +
    '.fg-feeds-head button{border:0;background:none;font-size:22px;line-height:1;color:#52635a;cursor:pointer}' +
    '.fg-feeds-sub{margin:0;padding:0 20px 10px;font-size:12px;color:#738379}' +
    '.fg-feeds-list{padding:0 20px 20px;display:grid;gap:12px}' +
    '.fg-feed{display:grid;grid-template-columns:150px 1fr;gap:12px;align-items:start;border:1px solid #dce8df;border-radius:14px;padding:10px}' +
    '.fg-feed video{width:150px;aspect-ratio:16/9;border-radius:10px;background:#0b1f19;object-fit:cover}' +
    '.fg-feed .nov{width:150px;aspect-ratio:16/9;border-radius:10px;background:#eef2ef;color:#738379;font-size:11px;display:grid;place-items:center;text-align:center}' +
    '.fg-feed b{display:block;font-size:14px}' +
    '.fg-feed small{display:block;margin-top:3px;font-size:12px;color:#738379}' +
    '.fg-feed .act{margin-top:8px;font-size:12px;color:#738379}' +
    '.fg-feed .act button{padding:0;border:0;background:none;color:#123f34;font:inherit;font-size:12px;font-weight:700;text-decoration:underline;cursor:pointer}' +
    '.fg-feeds-empty{padding:20px;text-align:center;color:#738379;font-size:13px}' +
    '@media(max-width:480px){.fg-feed{grid-template-columns:110px 1fr}.fg-feed video,.fg-feed .nov{width:110px}}';

  function statusText(rp) {
    if (rp.status === 'refunded') return 'Refunded ' + rp.coins + ' Heart Coin' + (rp.coins === 1 ? '' : 's');
    if (rp.status === 'rejected') return 'Reviewed \u00b7 food was dispensed';
    return 'Report received \u00b7 under review';
  }

  // put the link / status under each of the user's own clips (the grid is redrawn often, so this runs again each time)
  function decorate(fr) {
    var btns = fr.grid.querySelectorAll('button[data-share-clip-id]');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i], id = b.getAttribute('data-share-clip-id'), m = mine[id];
      var old = b.parentNode.querySelector('.recording-report,.recording-report-status');
      var html = !m ? '' : m.report ? '<span class="recording-report-status">' + esc(statusText(m.report)) + '</span>'
        : m.reportable ? '<button class="recording-report" type="button" data-report-clip-id="' + esc(id) + '">Report a problem</button>' : '';
      if (old && old.outerHTML === html) continue;
      if (old) old.remove();
      if (html) b.insertAdjacentHTML('afterend', html);
    }
  }

  function refresh(fr, force) {
    var a = auth(fr);
    if (!a || busy || (!force && Date.now() - fetchedAt < 20000)) return;
    busy = true; fetchedAt = Date.now();
    post('/api/my-clips', { auth: a }).then(function (r) {
      if (!r.ok) return;
      var m = {};
      if (r.j.windowHours) feedsWindow = r.j.windowHours;
      rows = r.j.clips || [];
      rows.forEach(function (x) { m[x.clip] = x; });
      mine = m;
      var f2 = frame();
      if (f2) { decorate(f2); renderFeeds(f2); }
    }).catch(function () {}).then(function () { busy = false; var w = waiters; waiters = []; w.forEach(function (f) { f(); }); });
  }

  function dialog(fr) {
    var d = fr.d.getElementById('clipReportDialog');
    if (d) return d;
    d = fr.d.createElement('dialog');
    d.id = 'clipReportDialog'; d.className = 'clip-report-dialog';
    d.innerHTML = '<form><h3>Report a problem</h3><p>Tell us what went wrong with this feeding. We\u2019ll check the clip and refund your Heart Coins if the feeder didn\u2019t dispense food.</p>' +
      '<label class="clip-report-opt"><input type="radio" name="kind" value="no_food" checked> The feeder didn\u2019t dispense food</label>' +
      '<textarea name="note" maxlength="300" rows="3" placeholder="Anything else we should know? (optional)"></textarea>' +
      '<p class="clip-report-err" hidden></p>' +
      '<div class="clip-report-act"><button type="button" data-report-cancel>Cancel</button><button type="submit">Submit report</button></div></form>';
    fr.d.body.appendChild(d);
    var form = d.querySelector('form'), err = d.querySelector('.clip-report-err'), send = d.querySelector('[type=submit]');
    d.querySelector('[data-report-cancel]').addEventListener('click', function () { d.close(); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (d.getAttribute('data-done')) { d.close(); return; }
      var a = auth(fr);
      if (!a) { err.textContent = 'Please sign in to report a feeding.'; err.hidden = false; return; }
      send.disabled = true; err.hidden = true;
      post('/api/report', { auth: a, clip: d.getAttribute('data-clip'), kind: form.kind.value, note: form.note.value.trim() }).then(function (r) {
        if (!r.ok) { err.textContent = r.j.error || 'Could not send the report. Please try again.'; err.hidden = false; return; }
        d.setAttribute('data-done', '1');
        form.querySelector('h3').textContent = 'Thanks, we got it';
        form.querySelector('p').textContent = 'We\u2019ll review the clip. If the feeder didn\u2019t dispense food, your Heart Coins go back to your account and we\u2019ll email you.';
        form.querySelector('.clip-report-opt').hidden = true; form.note.hidden = true;
        d.querySelector('[data-report-cancel]').hidden = true; send.textContent = 'OK';
        refresh(fr, true);
      }).catch(function () { err.textContent = 'Could not send the report. Please try again.'; err.hidden = false; })
        .then(function () { send.disabled = false; });
    });
    return d;
  }

  function open(fr, clipId) {
    var d = dialog(fr), form = d.querySelector('form');
    d.removeAttribute('data-done'); form.reset();
    form.querySelector('h3').textContent = 'Report a problem';
    form.querySelector('p').textContent = 'Tell us what went wrong with this feeding. We\u2019ll check the clip and refund your Heart Coins if the feeder didn\u2019t dispense food.';
    form.querySelector('.clip-report-opt').hidden = false; form.note.hidden = false;
    d.querySelector('[data-report-cancel]').hidden = false; d.querySelector('[type=submit]').textContent = 'Submit report';
    d.querySelector('.clip-report-err').hidden = true;
    d.setAttribute('data-clip', clipId);
    d.showModal();
  }

  // ---- "My feedings": a quiet link under the balance, opening the user's recent paid feeds with their clips
  function when(d) {
    var t = new Date(d * 1000);
    return t.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) + ', ' + t.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
  }
  function feedRow(x) {
    var media = x.url ? '<video controls preload="none" playsinline src="' + esc(API + x.url) + '"' + (x.poster ? ' poster="' + esc(API + x.poster) + '"' : '') + '></video>'
      : '<div class="nov">Video is still processing</div>';
    var act = x.report ? esc(statusText(x.report))
      : x.reportable ? '<button type="button" data-report-clip-id="' + esc(x.clip) + '">Report an issue</button>'
      : x.coins > 0 && x.ready ? 'Issues can be reported within ' + esc(feedsWindow) + ' hours' : '';
    return '<div class="fg-feed">' + media + '<div><b>' + esc(x.station) + '</b><small>' + esc(when(x.created)) + ' \u00b7 ' + esc(x.grams) + ' g \u00b7 ' + esc(x.coins) + ' Heart Coin' + (x.coins === 1 ? '' : 's') + '</small>' +
      (act ? '<div class="act">' + act + '</div>' : '') + '</div></div>';
  }
  var feedsWindow = 48;
  function renderFeeds(fr) {
    var d = fr.d.getElementById('fgFeedsDialog');
    if (!d || !d.open) return;
    var list = d.querySelector('.fg-feeds-list');
    var html = rows.length ? rows.map(feedRow).join('') : '<div class="fg-feeds-empty">No feedings with a video in the last 7 days.</div>';
    if (list.getAttribute('data-html') !== html) { list.setAttribute('data-html', html); list.innerHTML = html; }
  }
  function openFeeds(fr) {
    var d = fr.d.getElementById('fgFeedsDialog');
    if (!d) {
      d = fr.d.createElement('dialog');
      d.id = 'fgFeedsDialog'; d.className = 'fg-feeds-dialog';
      d.innerHTML = '<div class="fg-feeds-head"><h3>My feedings</h3><button type="button" aria-label="Close" data-feeds-close>\u00d7</button></div>' +
        '<p class="fg-feeds-sub">Your feedings from the last 7 days, with their videos.</p><div class="fg-feeds-list"></div>';
      fr.d.body.appendChild(d);
      d.querySelector('[data-feeds-close]').addEventListener('click', function () { d.close(); });
      d.addEventListener('click', function (e) {
        if (e.target === d) { d.close(); return; }
        var b = e.target.closest && e.target.closest('button[data-report-clip-id]');
        if (b) open(fr, b.getAttribute('data-report-clip-id'));
      });
    }
    var list = d.querySelector('.fg-feeds-list');
    if (!auth(fr)) { list.removeAttribute('data-html'); list.innerHTML = '<div class="fg-feeds-empty">Please sign in to see your feedings.</div>'; d.showModal(); return; }
    if (!rows.length) { list.removeAttribute('data-html'); list.innerHTML = '<div class="fg-feeds-empty">Loading\u2026</div>'; }
    d.showModal();
    renderFeeds(fr);
    waiters.push(function () { renderFeeds(fr); });
    if (busy) return;
    refresh(fr, true);
    if (!busy) { var w = waiters; waiters = []; w.forEach(function (f) { f(); }); }
  }
  function addFeedsLink(fr) {
    if (!auth(fr) || fr.d.getElementById('fgMyFeeds')) return;
    var shop = fr.d.querySelector('.balance-box');
    if (!shop) return;
    shop.insertAdjacentHTML('afterend', '<button type="button" id="fgMyFeeds" class="fg-myfeeds-link">My feedings</button>');
    fr.d.getElementById('fgMyFeeds').addEventListener('click', function () { openFeeds(fr); });
  }
  function setup(fr) {
    if (fr.grid.getAttribute('data-fg-report')) return;
    fr.grid.setAttribute('data-fg-report', '1');
    fr.grid.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('button[data-report-clip-id]');
      if (b) { e.stopPropagation(); open(fr, b.getAttribute('data-report-clip-id')); }
    }, true);
    new fr.w.MutationObserver(function () {
      decorate(fr);
      var ids = Array.prototype.map.call(fr.grid.querySelectorAll('button[data-share-clip-id]'), function (b) { return b.getAttribute('data-share-clip-id'); }).join(',');
      if (ids !== seen) { seen = ids; refresh(fr, ids.split(',').some(function (id) { return id && !mine[id]; }) && Date.now() - fetchedAt > 5000); }
    }).observe(fr.grid, { childList: true });
    refresh(fr, true);
  }

  setInterval(function () {
    var fr = frame();
    if (!fr) return;
    if (!fr.d.getElementById('fgReportCss')) {
      var st = fr.d.createElement('style'); st.id = 'fgReportCss'; st.textContent = CSS; fr.d.head.appendChild(st);
    }
    setup(fr);
    addFeedsLink(fr);
    if (!fr.d.hidden) refresh(fr, false);
  }, 2000);
})();
